import { type AuthenticationLoginInputType } from '@shelflix/schemas/authentication/login';
import { create } from 'zustand';

interface LoginFormStore {
  formData: Partial<AuthenticationLoginInputType>;
  setFormData: (data: Partial<AuthenticationLoginInputType>) => void;
  resetForm: () => void;
}

export const useLoginFormStore = create<LoginFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
